module.exports = __webpack_public_path__ + "static/media/kn.4092d4c5.svg";